import { useMemo } from 'react'

import Table from '~/components/Table'
import {
  ZoneVehiclesListQuery_zone_Zone_table_Vehicle as Vehicle,
  useZoneVehiclesListQuery,
} from '~/gql/generated/graphql'
import { columns } from '~/components/Vehicle/List'

type VehiclesInZoneProps = {
  id: string
}

const VehiclesInZone = ({ id }: VehiclesInZoneProps) => {
  const { data } = useZoneVehiclesListQuery({
    variables: {
      zone_id: id,
    },
  })

  const filteredVehicles = useMemo(
    () => data?.zone?.table?.filter(v => v?.detail?.module?.is_present),
    [data],
  )

  if (!data) {
    return null
  }
  const filteredData = { table: { nodes: filteredVehicles ?? [] } }

  return (
    <Table<Vehicle>
      columns={columns.filter(({ basic, zone }) => basic || zone)}
      data={filteredData}
    />
  )
}

export default VehiclesInZone
